import { DashBoardOwnPageComponent } from './components/dashboard-ownpage.component';
import { Route } from '@angular/router';

import {
  DashboardActivityResolver,
  DashboardDeviationResolver,
  DashboardRiskAnalysisResolver,
  DashboardNewsResolver,
  DashboardBusinessResolver,
  DashboardLoggedUserResolver,
  DashboardAboutKubaResolver,
  DashboardAppLoggedUserResolver,
  DashboardLinksListResolver,
  DashboardBusinessFunctionResolver,
  AboutKubaIKResolver,
  DashboardAdminNewsResolver,
  DashboardLinksPortalBusinessResolver,
  DashboardLinksForPortalBusinessResolver,
  DashboardBusinessLoginResolver
} from './Services/dashboard.resolver.service';
import { AuthGuard } from '../../_guards/index';
import { DashboardComponent } from './index';
import { FlexiCompliancePortalListComponent } from './components/flexi-compliance-portal-list/flexi-compliance-portal-list.component';

export const dashboardRoutes: Route[] = [
  {
    path: '',
    canActivate: [AuthGuard],
    resolve: {
      activity: DashboardActivityResolver,
      deviation: DashboardDeviationResolver,
      riskanalysis: DashboardRiskAnalysisResolver,
      business: DashboardBusinessResolver,
      businessLogins: DashboardBusinessLoginResolver,
      loggedUser: DashboardLoggedUserResolver,
      appLoggedUser: DashboardAppLoggedUserResolver,
      aboutUs: DashboardAboutKubaResolver,
      links: DashboardLinksListResolver,
      businessFunction: DashboardBusinessFunctionResolver,
      internalNews: DashboardNewsResolver,
      adminNews: DashboardAdminNewsResolver,
      PortalBusiness: DashboardLinksPortalBusinessResolver,
      PortalLinks: DashboardLinksForPortalBusinessResolver
    },
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent
      },
      {
        path: 'dashboard-ownpage/:data',
        component: DashBoardOwnPageComponent,
        resolve: {
          aboutKubaIk: AboutKubaIKResolver
        }
      }
    ]
  },
  // Portal compliance business list — reached from the dashboard pie
  // chart. Registered OUTSIDE the resolver-heavy parent so opening it
  // doesn't refetch every dashboard payload.
  {
    path: 'dashboard/flexi-compliance',
    canActivate: [AuthGuard],
    component: FlexiCompliancePortalListComponent
  }
];
